import React, { useState, useEffect, useRef } from 'react';
import styles from "./branchorder.module.css";
import { getFetch } from '../../../fetch/fetch';
import OrderPage from './orderpage';
import HistoryPage from './historypage';
import AdminPage from './adminpage';

// 물품 주문 (사이드바 '물품 주문') — 물품 주문 / 주문내역 / 관리자페이지(본사직원만)
// 서버: /api/branch-orders (peetsunbaeserver router/branchOrder.ts). 선배봇이 슬랙에서 받아 쿠팡 주문
const BranchOrderMain: React.FC<any> = (props: any) => {

    const [tab, setTab] = useState<"order" | "history" | "admin">("order");
    const [init, setInit] = useState<any>(null);
    const [orders, setOrders] = useState<any[]>([]);
    const [openOrderId, setOpenOrderId] = useState<number | null>(null);
    const [update, setUpdate] = useState(0);

    useEffect(() => {
        props.activateMenuList("branchorder");
    }, []);

    useEffect(() => {
        if (!props.user) return;
        getInit();
    }, [props.user]);

    useEffect(() => {
        if (!props.user) return;
        getOrders();
    }, [props.user, update, props.branchOrderUpdate]);

    const getInit = async () => {
        try {
            const result: any = await getFetch("/api/branch-orders/init");
            if (result.message === "success") {
                setInit(result.data);
            }
        } catch (e) {
            console.log(e);
        }
    }

    //연달아 재조회할 때 늦게 온 앞선 응답이 최신 목록을 덮어쓰지 않도록
    const ordersSeqRef = useRef(0);

    const getOrders = async () => {
        const seq = ++ordersSeqRef.current;
        try {
            const result: any = await getFetch("/api/branch-orders");
            if (seq !== ordersSeqRef.current) return;
            if (result.message === "success") {
                setOrders(result.data);
            }
        } catch (e) {
            console.log(e);
        }
    }

    // 접수 직후 주문내역으로 이동 + 그 주문 펼침
    const handleSubmitted = (orderId: number) => {
        setOpenOrderId(orderId);
        setTab("history");
        setUpdate(Math.random());
    }

    return (
        <div className={styles.root}>
            <div className={styles.page}>
                <nav className={styles.tabs} aria-label="물품 주문 메뉴">
                    <button type="button" className={`${styles.tab} ${tab === "order" ? styles.active : ""}`} onClick={() => setTab("order")}>물품 주문</button>
                    <button type="button" className={`${styles.tab} ${tab === "history" ? styles.active : ""}`} onClick={() => setTab("history")}>
                        주문내역 <span className={`${styles.count} ${styles.num}`}>{orders.length}</span>
                    </button>
                    {
                        init && init.isAdmin &&
                        <button type="button" className={`${styles.tab} ${tab === "admin" ? styles.active : ""}`} onClick={() => setTab("admin")}>관리자페이지</button>
                    }
                </nav>

                {
                    !init ?
                        <div className={styles.empty}>불러오는 중…</div>
                        :
                        <>
                            {tab === "order" && <OrderPage init={init} onSubmitted={handleSubmitted} />}
                            {tab === "history" && <HistoryPage init={init} user={props.user} orders={orders} openOrderId={openOrderId} setOpenOrderId={setOpenOrderId} reload={() => setUpdate(Math.random())} branchOrderUpdate={props.branchOrderUpdate} />}
                            {tab === "admin" && init.isAdmin && <AdminPage init={init} reloadInit={getInit} />}
                        </>
                }
            </div>
        </div>
    )
}

export default BranchOrderMain;
